import React from "react";

/* Actual client logos, presented as printed "logo plates" on the poster. */
export const LOGO_META = {
  autoroble: { src: "/logos/autoroble.jpg", bg: "#ED1C24", alt: "Auto Roble logo" },
  tacosfridamtl: { src: "/logos/tacosfrida.jpg", bg: "#FF2E88", alt: "Tacos Frida MTL logo" },
  distriroble: { src: "/logos/distriroble.png", bg: "#17294F", alt: "Distri Roble logo" },
  viniltv: { src: "/logos/vinil.jpg", bg: "#FFFFFF", alt: "Vinil TV logo" },
  ora: { src: "/logos/ora.png", bg: "#FFFFFF", alt: "ORA Boutique logo" },
  emporium: { src: "/logos/emporium.png", bg: "#F1ECE3", alt: "Montréal Emporium logo" },
};

export const BrandLogo = ({ brand, className = "", testId }) => {
  const m = LOGO_META[brand];
  if (!m) return null;
  return (
    <span
      className={`inline-block rounded-2xl overflow-hidden shadow-2xl ring-1 ring-black/10 ${className}`}
      style={{ background: m.bg }}
      data-testid={testId}
    >
      <img src={m.src} alt={m.alt} draggable="false" className="block w-full h-auto select-none" />
    </span>
  );
};
